<p-dialog [(visible)]="visible" [modal]="true" [closable]="false" [style]="{ width: '640px' }"
  styleClass="history-dialog" [showHeader]="false">
  <div class="history-modal-inner">

    <div class="history-modal-header">
      <div class="hh-left">
        <span class="hh-icon"><i class="pi pi-clock"></i></span>
        <span class="hh-title">View History</span>
      </div>
      <button class="modal-close-btn" (click)="close()">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <div class="history-modal-body">
      <div *ngIf="groups.length === 0" class="history-empty">
        <i class="pi pi-inbox"></i>
        <span>No history yet for this application.</span>
      </div>

      <div class="history-timeline" *ngIf="groups.length > 0">
        <ng-container *ngFor="let group of groups">
          <div class="hist-date">{{ group.label }}</div>

          <div class="hist-item" *ngFor="let entry of group.entries">
            <div class="hist-rail">
              <span class="hist-dot" [ngClass]="entry.badgeClass"><i [class]="entry.iconClass"></i></span>
            </div>
            <div class="hist-card">
              <div class="hist-card-head">
                <span class="hist-title">{{ entry.title }}</span>
                <div class="hist-head-right">
                  <span class="hist-time" *ngIf="entry.time">{{ entry.time }}</span>
                  <button *ngIf="canEdit" class="hist-edit-btn" title="Edit this upload" (click)="onEdit(entry)">
                    <i class="pi pi-pencil"></i>
                  </button>
                </div>
              </div>

              <p class="hist-desc" *ngIf="entry.remarks">{{ entry.remarks }}</p>

              <div class="hist-tags">
                <span class="status-badge" [ngClass]="entry.badgeClass">
                  <span class="status-dot"></span>{{ entry.title }}
                </span>
              </div>

              <div class="hist-detail" *ngIf="(canEdit && entry.internalNotes) || entry.attachments.length">
                <div class="hist-detail-row" *ngIf="canEdit && entry.internalNotes">
                  <span class="hist-detail-label">Internal Notes</span>
                  <span class="hist-detail-value">{{ entry.internalNotes }}</span>
                </div>
                <div class="hist-file-row" *ngFor="let att of entry.attachments">
                  <span class="file-badge" [ngClass]="att.badge.className">{{ att.badge.label }}</span>
                  <a class="hist-file-link" [href]="att.url" target="_blank" [title]="att.name">{{ att.name }}</a>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="history-modal-footer" *ngIf="canEdit">
      <button class="btn-export" (click)="exportHistory()">
        <i class="pi pi-download"></i> Export Log
      </button>
    </div>

  </div>
</p-dialog>
